/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import axios from 'axios';
import { API_URL } from '../constants';
import type { AxiosReturn } from '../types/return.types';
import { getAPIToken } from '../utils';

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Authorization = `Bearer ${getAPIToken()}`;

export class SupportService {
  static async getPrescriptionTasks(): Promise<AxiosReturn> {
    return new Promise((resolve) => {
      axios
        .get('/support/prescription-tasks')
        .then((response) => {
          resolve({ error: false, message: 'Success', data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: 'Error', data: error });
        });
    });
  }

  static async sendPrescriptions(formData: FormData): Promise<AxiosReturn> {
    return new Promise((resolve) => {
      axios
        .post('/support/send-prescription', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then((response) => {
          resolve({ error: false, message: 'Success', data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: 'Error', data: error });
        });
    });
  }
}
